import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';


import { richTextFieldActions } from '../actions/richTextField';

export type RichTextFieldState = {
  meta: {
    addAttachments: AsyncStatus;
  };
};

const initialState: RichTextFieldState = {
  meta: {
    addAttachments: 'succeeded',
  },
};

export const {
  richTextFieldAddAttachments,
  richTextFieldAddAttachmentsSucceeded,
  richTextFieldAddAttachmentsFailed,
} = richTextFieldActions;

const richTextField = handleActions<RichTextFieldState, any>(
  {
    [richTextFieldAddAttachments.toString()]: (state: RichTextFieldState) => {
      return { ...state, meta: { ...state.meta, addAttachments: 'loading' } };
    },

    [richTextFieldAddAttachmentsSucceeded.toString()]: (
      state: RichTextFieldState,
    ) => {
      return { ...state, meta: { ...state.meta, addAttachments: 'succeeded' } };
    },

    [richTextFieldAddAttachmentsFailed.toString()]: (
      state: RichTextFieldState,
    ) => {
      return { ...state, meta: { ...state.meta, addAttachments: 'failed' } };
    },
  },
  initialState,
);

export default richTextField;
